"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeToString = exports.timeToDate = exports.parseTimeString = exports.parseTimeInterval = exports.getMinutes = exports.getHours = exports.calculateTimeFrames = exports.getTimeLabel = exports.getTime24 = exports.getTime12 = exports.getDateLabel = exports.getLevelText = exports.getGradeText = exports.getSubjectText = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getSubjectText = function getSubjectText(subjectId, filters) {
  if (!subjectId) {
    return 'All';
  }

  var subject = filters.groups.find(function (val) {
    return val.id === subjectId;
  });

  if (subject && subject.title) {
    return subject.title;
  }

  console.warn("Couldn't find subject with id ".concat(subjectId, " in the subjects list"));
  return 'All';
};

exports.getSubjectText = getSubjectText;

var getGradeText = function getGradeText(grade, filters) {
  if (!grade) {
    return 'All';
  }

  return filters.gradesList.find(function (val) {
    return val.id === Number(grade);
  }).title;
};

exports.getGradeText = getGradeText;

var getLevelText = function getLevelText(level, filters) {
  if (!level) {
    return 'All';
  }

  return filters.levels.find(function (val) {
    return val.id === level;
  }).name;
};

exports.getLevelText = getLevelText;

var getDateLabel = function getDateLabel(dates) {
  if (!dates) return null;
  return dates.reduce(function (total, current) {
    var date = new Date(current);
    if (Number.isNaN(date.valueOf())) return total;
    var dateString = date.toLocaleDateString('en-AU', {
      day: '2-digit',
      month: 'short'
    });
    return total.concat(total.length ? ", ".concat(dateString) : dateString);
  }, '');
};

exports.getDateLabel = getDateLabel;

var getTime12 = function getTime12(timeString) {
  if (!timeString) return null;
  var parsed = timeString.split(':');
  var hourFormat = Number(parsed[0]) % 24;
  var timeOfDay = Number(hourFormat) < 12 ? 'AM' : 'PM';
  var hour = Number(hourFormat) % 12 || 12;
  var hourString = hour < 10 ? "0".concat(hour) : hour.toString();
  return "".concat(hourString, ":").concat(parsed[1], " ").concat(timeOfDay);
};

exports.getTime12 = getTime12;

var getTime24 = function getTime24(time12) {
  if (!time12) return null;
  var slice = time12.slice(0, 5);
  var timeOfDay = time12.slice(5).trim();
  var parsed = slice.split(':');
  var hour = timeOfDay === 'PM' ? (Number(parsed[0]) + 12) % 24 || 12 : parsed[0];
  var hourString = hour < 10 ? "0".concat(hour) : hour.toString();
  return "".concat(hourString, ":").concat(parsed[1]);
};

exports.getTime24 = getTime24;

var getTimeLabel = function getTimeLabel(time) {
  if (!time) return null;
  var start = time.start,
      end = time.end;
  var startTime = getTime12(start);
  var endTime = getTime12(end);
  return "".concat(startTime, " - ").concat(endTime);
};

exports.getTimeLabel = getTimeLabel;

var calculateTimeFrames = function calculateTimeFrames() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var array = [];

  for (var i = min; i <= max; i++) {
    if (i < max) {
      array.push("".concat(i, ":00"), "".concat(i, ":30"));
      /* eslint-disable-next-line */

      continue;
    }

    array.push("".concat(i, ":00"));
  }

  return array.map(function (val, idx) {
    return {
      title: val,
      id: idx
    };
  });
};

exports.calculateTimeFrames = calculateTimeFrames;

var getHours = function getHours() {
  var hours = [];

  for (var i = 0; i < 12; i++) {
    var hour = i === 0 ? 12 : i;
    var string = hour < 10 ? "0".concat(hour) : hour.toString();
    hours.push({
      value: string,
      id: string
    });
  }

  return hours;
};

exports.getHours = getHours;

var getMinutes = function getMinutes() {
  var minutes = [];

  for (var i = 0; i < 60; i += 15) {
    var string = i < 10 ? "0".concat(i) : i.toString();
    minutes.push({
      value: string,
      id: string
    });
  }

  return minutes;
};

exports.getMinutes = getMinutes;

var parseTimeInterval = function parseTimeInterval(interval) {
  var separator = ' - ';

  if (!interval || !interval.includes(separator)) {
    return null;
  }

  var _interval$split = interval.split(separator),
      _interval$split2 = _slicedToArray(_interval$split, 2),
      startTime = _interval$split2[0],
      endTime = _interval$split2[1];

  return {
    start: parseTimeString(startTime),
    end: parseTimeString(endTime)
  };
};

exports.parseTimeInterval = parseTimeInterval;

var parseTimeString = function parseTimeString(time, defaultValue) {
  if (!time) return defaultValue;
  var parsed = time.split(':');
  var timeOfDay = Number(parsed[0]) < 12 ? 'AM' : 'PM';
  var hour = Number(parsed[0]) % 12 || 12;
  var hourString = hour < 10 ? "0".concat(hour) : hour.toString();
  return [hourString, parsed[1], timeOfDay];
};

exports.parseTimeString = parseTimeString;

var timeToDate = function timeToDate(timeString) {
  var _timeString$split = timeString.split(':'),
      _timeString$split2 = _slicedToArray(_timeString$split, 2),
      hour = _timeString$split2[0],
      minute = _timeString$split2[1];

  return new Date().setHours(hour, minute, 0, 0);
};

exports.timeToDate = timeToDate;

var timeToString = function timeToString(time) {
  if (!time || !time.length) {
    return '00:00';
  }

  var minute = time[1];
  var timeOfDay = time[2];
  var hour = timeOfDay === 'AM' ? time[0] % 12 : time[0] % 12 + 12;
  var hourString = hour < 10 ? "0".concat(hour) : hour.toString();
  return "".concat(hourString, ":").concat(minute);
};

exports.timeToString = timeToString;